export const RECIPES_REQUEST = "RECIPES_REQUEST";
export const RECIPES_FAILURE = "RECIPES_FAILURE";
export const GET_RECIPES_SUCCESS = "GET_RECIPES_SUCCESS";
export const DELETE_RECIPES_SUCCESS = "DELETE_RECIPES_SUCCESS";